import { z } from "zod";
import {
  forbiddenCategorySchema,
  forbiddenMatchTypeSchema,
  severitySchema,
} from "../enums.js";
import { isoDate } from "./common.js";

export const forbiddenExpressionSchema = z.object({
  id: z.string(),
  category: forbiddenCategorySchema,
  expression: z.string(),
  note: z.string().nullable(),
  suggestion: z.string().nullable(),
  severity: severitySchema,
  matchType: forbiddenMatchTypeSchema,
  isActive: z.boolean(),
  createdAt: isoDate,
  updatedAt: isoDate,
});
export type ForbiddenExpression = z.infer<typeof forbiddenExpressionSchema>;

export const createForbiddenExpressionSchema = z.object({
  category: forbiddenCategorySchema,
  expression: z.string().trim().min(1).max(300),
  note: z.string().trim().max(2000).optional(),
  suggestion: z.string().trim().max(1000).optional(),
  severity: severitySchema.optional(),
  matchType: forbiddenMatchTypeSchema.optional(),
});
export type CreateForbiddenExpressionInput = z.infer<typeof createForbiddenExpressionSchema>;

export const updateForbiddenExpressionSchema = z.object({
  category: forbiddenCategorySchema.optional(),
  expression: z.string().trim().min(1).max(300).optional(),
  note: z.string().trim().max(2000).nullable().optional(),
  suggestion: z.string().trim().max(1000).nullable().optional(),
  severity: severitySchema.optional(),
  matchType: forbiddenMatchTypeSchema.optional(),
  isActive: z.boolean().optional(),
});
export type UpdateForbiddenExpressionInput = z.infer<typeof updateForbiddenExpressionSchema>;

export const importForbiddenExpressionsSchema = z.object({
  entries: z.array(createForbiddenExpressionSchema).min(1).max(2000),
  /** When true an existing entry with the same expression is overwritten. */
  replaceExisting: z.boolean().default(false),
});
export type ImportForbiddenExpressionsInput = z.infer<typeof importForbiddenExpressionsSchema>;

export const importForbiddenExpressionsResultSchema = z.object({
  created: z.number().int().nonnegative(),
  updated: z.number().int().nonnegative(),
  skipped: z.number().int().nonnegative(),
});
export type ImportForbiddenExpressionsResult = z.infer<
  typeof importForbiddenExpressionsResultSchema
>;
